<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`编辑试验日期`"
    width="600px"
    height="400px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="editLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item label="报告编号" prop="reportCode">
            <el-input disabled v-model.trim="editForm.reportCode" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测项目" prop="sampleName">
            <el-input disabled v-model.trim="editForm.sampleName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="样品数量" prop="sampleCnt">
            <el-input disabled v-model.trim="editForm.sampleCnt" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="试验日期" prop="testedTime">
            <el-date-picker
              v-model="editForm.testedTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { editFlowDeliverTestedTime } from '@/api/flow';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      editLoading: false,
      editForm: {
        testedTime: ''
      },
      rules: {
        testedTime: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeInfo.id) {
        this.setFormValues();
      }
    }
  },
  methods: {
    setFormValues() {
      this.editForm = {
        ...this.activeInfo
      };
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          try {
            await editFlowDeliverTestedTime({
              entrustmentId: this.activeInfo.entrustmentId,
              testedTime: this.editForm.testedTime
            });

            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped></style>
